import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useState } from "react";
import { internalWithdrawsSchema } from "../../lib/validation";
import CustomPayemntNumberInput from "../../ui/payment/CustomPayemntNumberInput";
import CustomPaymentInput from "../../ui/payment/CustomPaymentInput";
import Loader from "../../shared/Loader";
import { useInternalWithdraw } from "../../lib/queries/queriesAndMutations";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { removeLoSt } from "../../utils/utils";
import TextArea from "../../ui/TextArea";
import { useNavigate } from "react-router-dom";

export default function InternalTransferForm({ balance }) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [showCreateNewAccount, setShowCreateNewAccount] = useState(false);

  const {
    watch,
    reset,
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
      mobile: "",
      description: "",
    },
    resolver: zodResolver(internalWithdrawsSchema),
  });

  const { mutateAsync: internalWithdraw, isPending } = useInternalWithdraw();

  const amount = watch("amount");
  const iban = watch("iban");

  useEffect(() => {
    setShowCreateNewAccount(false);
  }, [amount, iban]);

  const processForm = async (data) => {
    if (removeLoSt(data?.amount) > balance) {
      alert("موجودی ناکافی");
      return;
    }
    try {
      const res = await internalWithdraw(data);
      //console.log({ res });
      if (res?.status === 200 || res?.status === 201) {
        navigate("/withdrawals/list");
        queryClient.invalidateQueries({ queryKey: ["getMoneyTransferReqs"] });
        toast.success("با موفقیت ثبت شد");
        
        reset();
      }
    } catch (error) {
      //console.log({ error });
    }
  };

  return (
    <div className="w-full flex flex-col gap-1">
      <form
        onSubmit={handleSubmit(processForm)}
        className="flex flex-col w-full gap-3 ">
        <CustomPayemntNumberInput
          control={control}
          name={"amount"}
          label={"مبلغ (ریال)*"}
          placeholder={"مبلغ به ریال"}
          type={"number"}
          errors={errors.amount}
        />
        <CustomPaymentInput
          register={register}
          name={"mobile"}
          label={"شماره موبایل"}
          placeholder={"*******0912"}
          type={"number"}
          errors={errors.amount}
        />

        <TextArea
          control={control}
          placeholder={"توضیحات خود را اینجا بنویسید"}
          name={"description"}
          label={"شرح تراکنش"}
          type={"text"}
        />

        <div className=" flex">
          <div className="flex gap-1 mr-auto ">
            <button
              className="secondary-btn"
              onClick={(e) => {
                e.preventDefault();
                navigate("/withdrawals/list");
              }}>
              بازگشت
            </button>
            <button
              type="submit"
              className="primary-btn disabled:bg-slate-500 "
              disabled={isPending}>
              {isPending ? (
                <p className="flex gap-1 ">
                  <div className="w-6 h-6">
                    <Loader />
                  </div>{" "}
                </p>
              ) : (
                "درخواست انتقال"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
